import Base from './base';
import focusableElements from '../utils/focusable-elements';

class Sidebar extends Base {
	constructor(el) {
		super(el);

		this.externalToggle = this.query(`[aria-controls=${this.el.id}]`, document.body);

		this.on('click', this.refs.sidebarClose);

		if (this.externalToggle) {
			this.on('click', this.externalToggle);
		}
	}

	get isExpanded() {
		return this.el.hasAttribute('aria-expanded');
	}

	set isExpanded(expanded) {
		if (expanded) {
			this.el.setAttribute('aria-expanded', true);
		} else {
			this.el.removeAttribute('aria-expanded');
		}
	}

	onClick(e) {
		e.stopPropagation();

		if (this.isExpanded && e.target !== this.externalToggle && !this.el.contains(e.target)) {
			return this.close();
		}

		if (e.target === this.externalToggle) {
			return this.toggleExpanded();
		}

		if (e.target === this.refs.sidebarClose) {
			return this.close();
		}

		return true;
	}

	onKeydown(e) {
		const { keyCode } = e;

		// ESC
		if (keyCode === 27) {
			this.close();
		}
	}

	toggleExpanded() {
		if (this.isExpanded) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.isExpanded = true;
		this.focus();

		this.on('keydown', document.body);
		this.on('click', document.body);
	}

	close() {
		this.isExpanded = false;

		this.off('keydown', document.body);
		this.off('click', document.body);
	}

	focus() {
		const firstInput = this.query(focusableElements);

		if (firstInput) {
			firstInput.focus();
		}
	}
}

export default Sidebar;
